"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZAPIER_TEMPLATE_JSON_PATH = exports.PLATFORM_NAVIGATION_LOGO_PATH = exports.PLATFORM_INTEGRATION_LOGO_S_FILENAME = exports.PLATFORM_INSIDED_NAME = exports.PLATFORM_INSIDED_LOGO = exports.PLATFORM_GS_LOGO_PATH = exports.PLATFORM_BRAND_NAME_POSSESSIVE_FORM = exports.PLATFORM_BRAND_NAME = exports.INTEGRATION_TAB_JSON_PATH = void 0;

var _common = require("@insided/shared/utils/common");

var isCCRebranding = _common.common.isModuleActive('ccRebranding');

var PLATFORM_INTEGRATION_LOGO_S_FILENAME = isCCRebranding ? 'cc-logo-s' : 'digital-hub-s'; // Note: There is no  beginning slash in the path below.

exports.PLATFORM_INTEGRATION_LOGO_S_FILENAME = PLATFORM_INTEGRATION_LOGO_S_FILENAME;
var PLATFORM_GS_LOGO_PATH = isCCRebranding ? 'images/gainsight-customer-community.svg' : 'images/gainsight-digital-hub.png';
exports.PLATFORM_GS_LOGO_PATH = PLATFORM_GS_LOGO_PATH;
var PLATFORM_NAVIGATION_LOGO_PATH = isCCRebranding ? 'images/navigation/customer_community.svg' : 'images/navigation/digital_hub.svg';
exports.PLATFORM_NAVIGATION_LOGO_PATH = PLATFORM_NAVIGATION_LOGO_PATH;
var PLATFORM_BRAND_NAME = isCCRebranding ? 'Customer Communities' : 'Digital Hub';
exports.PLATFORM_BRAND_NAME = PLATFORM_BRAND_NAME;
var PLATFORM_BRAND_NAME_POSSESSIVE_FORM = "".concat(PLATFORM_BRAND_NAME, "'s");
exports.PLATFORM_BRAND_NAME_POSSESSIVE_FORM = PLATFORM_BRAND_NAME_POSSESSIVE_FORM;
var PLATFORM_INSIDED_NAME = isCCRebranding ? 'Customer Communities' : 'inSided';
exports.PLATFORM_INSIDED_NAME = PLATFORM_INSIDED_NAME;
var PLATFORM_INSIDED_LOGO = isCCRebranding ? 'images/CC-logo-no-text' : 'images/logo-no-text';
exports.PLATFORM_INSIDED_LOGO = PLATFORM_INSIDED_LOGO;
var ZAPIER_TEMPLATE_JSON_PATH = isCCRebranding ? 'zapTemplates_CC.json' : 'zapTemplates.json';
exports.ZAPIER_TEMPLATE_JSON_PATH = ZAPIER_TEMPLATE_JSON_PATH;
var INTEGRATION_TAB_JSON_PATH = isCCRebranding ? 'tabTemplates_CC.json' : 'tabTemplates.json';
exports.INTEGRATION_TAB_JSON_PATH = INTEGRATION_TAB_JSON_PATH;